import { Peripherals } from 'entities/Peripherals/interfaces';
import { SecurityGate } from 'entities/SecurityGate/interfaces';
import { Actions } from './actions';
import {
  GET_PERIPHERALS_ERROR,
  GET_PERIPHERALS_REQUEST,
  GET_PERIPHERALS_SUCCESS,
  GET_SECURITY_GATE_ERROR,
  GET_SECURITY_GATE_REQUEST,
  GET_SECURITY_GATE_SUCCESS,
  SET_DEP_TITLE,
} from './constants';

export const initialState = {
  loading: false as boolean,
  peripheralsError: null as null | Error,
  secGateError: null as null | Error,
  depTitle: JSON.parse(localStorage.getItem('depTitle') || 'null') as { id: string; name: string } | null,
  securityGate: [] as SecurityGate[] | [],
  peripherals: null as null | Peripherals[],
};

export type HeaderState = typeof initialState;

export const headerReducer = (state: HeaderState = initialState, action: Actions): HeaderState => {
  switch (action.type) {
    case GET_PERIPHERALS_REQUEST:
    case GET_SECURITY_GATE_REQUEST: {
      return {
        ...state,
        loading: true,
        peripheralsError: null,
        secGateError: null,
      };
    }
    case GET_SECURITY_GATE_SUCCESS: {
      return {
        ...state,
        loading: false,
        securityGate: action.payload,
        secGateError: null,
      };
    }
    case GET_SECURITY_GATE_ERROR: {
      return {
        ...state,
        loading: true,
        securityGate: [],
        secGateError: action.payload,
      };
    }
    case GET_PERIPHERALS_SUCCESS: {
      return {
        ...state,
        loading: false,
        peripheralsError: null,
        peripherals: action.payload,
      };
    }
    case GET_PERIPHERALS_ERROR: {
      return {
        ...state,
        loading: true,
        peripherals: null,
        peripheralsError: action.payload,
      };
    }
    case SET_DEP_TITLE: {
      return {
        ...state,
        loading: false,
        peripheralsError: null,
        depTitle: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
